import clsx from "clsx";

import { type TableTreeColumn } from "@devexpress/dx-react-grid-bootstrap4";

export const TableTreeColumnIndent = ({
  level,
}: TableTreeColumn.IndentProps) => {
  const maxIndentLevel = 1;

  return (
    <>
      {Array(level)
        .fill(null)
        .map((_, index) => (
          <div key={index} className="shrink-0 w-[34px]" />
        ))}
      {maxIndentLevel > 0 && level === maxIndentLevel && (
        <div
          className={clsx("shrink-0 flex items-center justify-end", {
            "w-[34px] pr-4": true,
          })}
        >
          <i
            className={clsx(
              "fa-regular fa-sharp fa-arrow-turn-down-right",
              "text-gray-1 group-hover/row:text-cosmic+1",
            )}
          />
        </div>
      )}
    </>
  );
};
